import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, withRouter } from "react-router-dom";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import { generateRequestOptions, homeUrl } from "../../shared/utils/apiEndPoints";
import { connect } from "react-redux";
import LogoHorizontal from "../../assets/logo/horizontal.svg";
import LogoSquare from "../../assets/logo/square.svg";
// import IdIcon from "../../assets/icons/indo.png";
// import EnIcon from "../../assets/icons/eng.png";
import "./Header.scss";
import Image from "../../shared/component/UI/Image";
import {
	BookIconOutline,
	// CaretDown,
	GradCapIconOutline,
	HeartIconFilled,
	HeartIconOutline,
	IconPortalSekolah,
	LogoutIconFilled,
	SearchIcon,
	StudentIconOutline,
	SuitcaseIconOutline,
	TopRightArrowIcon,
	UserCircleIconFilled,
	UserCircleIconOutline,
} from "../../shared/component/svg/Icons";
import { Overlay } from "react-bootstrap";
import Anchor from "../../shared/component/UI/Anchor";
import useDebounce from "../../shared/hooks/debounce";
import makeRequest from "../../shared/utils/request";
import { formatString } from "../../shared/utils/string";
import WhatsappStickyBtn from "../../shared/component/WhatsappStickyBtn";
// import cookies from "react-cookies";

const Header = ({ ENV_NAME, isAuthenticated, userDetails, setLoginModalShow, favorites, ...props }) => {
	const [search, setSearch] = useState("");
	const [searchTemp, setSearchTemp] = useState("");
	const [searchRes, setSearchRes] = useState(null);
	const [showOverlay, setShowOverlay] = useState(false);
	const [searchFocus, setSearchFocus] = useState(false);
	const [showDropdown, setShowDropdown] = useState(false);
	// const [showLangDropdown, setShowLangDropdown] = useState(false);
	const searchRef = useRef(null);
	const searchResRef = useRef(null);
	const profileRef = useRef(null);
	// const languageRef = useRef(null);
	const location = useLocation();
	const debounceSearch = useDebounce(searchTemp, 750);

	// Debounce - Setting the temp value to the search, and it'll call search API
	useEffect(() => {
		if (searchTemp !== search && (searchTemp.length >= 3 || searchTemp === "")) {
			setSearch(searchTemp);
		}
	}, [debounceSearch]); // eslint-disable-line

	useEffect(() => {
		const autoComplete = async (search) => {
			let res = await makeRequest(
				generateRequestOptions("globalSearch", { queryParams: { autocomplete: search } })
			);
			if (res?.code === 200) {
				setSearchRes(res?.data);
			}
		};

		if (search) {
			autoComplete(search);
		} else {
			setSearchRes(null);
		}
	}, [search]);

	// It's active if the pathname is part of one of the array
	const checkActiveOn = (pathname, arr) => {
		return arr?.some((i) => pathname?.includes(i));
	};

	// Function to show and hide dropdown (will also show overlay when opened)
	const openDropdown = (open = true, type = "profile") => {
		if (type === "profile") {
			setShowDropdown(open);
		// } else if (type === "language") {
		// 	// setShowLangDropdown(open);
		// }
		}
		if (document.activeElement === searchRef?.current && !open) return;
		setShowOverlay(open);
	};

	// Function to show and hide dropdown (will also show overlay when opened)
	const openSearchRes = (open = true) => {
		setShowOverlay(open);
		setSearchFocus(open);
	};

	// There are some issues when logged-out the overlay still opens
	// This will fixed it I hope
	useEffect(() => {
		openDropdown(false);

		if (isAuthenticated) {
			props.loadFavorites();
		}
	}, [isAuthenticated]); // eslint-disable-line

	// Our own useOutside callback
	useEffect(() => {
		function outside(event) {
			if (!searchRef.current?.contains(event.target) && !searchResRef.current?.contains(event.target)) {
				openSearchRes(false);
			}
		}
		document.addEventListener("mousedown", outside);
		return () => document.removeEventListener("mousedown", outside);
	}, [searchRef, searchResRef]);

	// Function to change the language
	// const changeLang = async (lang) => {
	// 	if (lang !== ENV_NAME) {
	// 		let val = lang;
	// 		await cookies.save("lang", val, {
	// 			domain: homeUrl,
	// 			path: "/",
	// 			expires: new Date("9999-12-31T12:00:00.000Z"),
	// 		});
	// 		await props.changeLanguage(val);
	// 		window.location.reload();
	// 	}
	// };

	useEffect(() => {
		if (searchFocus && searchRef?.current) {
			searchRef?.current?.focus();
		}
	}, [searchFocus]);

	return (
		<>
			<nav className="header-nav">
				<div className="container hn-content">
					<div className="d-flex align-items-center">
						<Link to={RoutePath.ROOT} className={showOverlay && searchFocus ? "show-desktop" : ""}>
							<Image className="show-desktop" src={LogoHorizontal} alt="logo" />
							<Image className="show-mobile mobile-logo" src={LogoSquare} alt="logo" />
						</Link>
						{showOverlay && searchFocus && (
							<TopRightArrowIcon
								className="back-arrow cursorPointer show-mobile"
								stroke="#232230"
								width="3rem"
								height="3rem"
								onClick={() => openSearchRes(false)}
							/>
						)}
						<div
							className={`ms-std cursorPointer show-xtra-small-mobile ${searchFocus ? "d-none" : ""}`}
							onClick={() => openSearchRes(true)}
						>
							<SearchIcon className="searchIcon" />
						</div>
					</div>
					<div className={`form-group search-bar ${searchFocus ? "" : "show-xtra-small-desktop"}`}>
						<SearchIcon className="searchIcon" />
						<input
							type="text"
							name="searchText"
							value={searchTemp || ""}
							onChange={(e) => setSearchTemp(e.target.value)}
							placeholder={Variable.HEADER_SRC_PLACEHOLDER[ENV_NAME]}
							onFocus={() => openSearchRes(true)}
							ref={searchRef}
						/>
					</div>
					<div className="d-flex align-items-center">
					{/* <div
						className={`px-std py-xs cursorPointer ${showLangDropdown ? "active" : ""} ${
							showOverlay && searchFocus ? "show-desktop" : ""
						}`}
						onMouseEnter={() => openDropdown(true, "language")}
						onMouseLeave={() => openDropdown(false, "language")}
						onClick={() => openDropdown(true, "language")}
						ref={languageRef}
					>
						<div className="flex-all-center">
							{ENV_NAME === "eng" ? (
								<Image className="lang-logo" src={EnIcon} alt="logo" />
							) : (
								<Image className="lang-logo" src={IdIcon} alt="logo" />
							)}
							<CaretDown className="ms-xs" stroke="#193560" width="1.6rem" height="1.6rem" />
						</div>
						<Overlay target={languageRef.current} show={showLangDropdown} placement="bottom-end">
							{({ placement, arrowProps, show: _show, popper, ...OverlayProps }) => (
								<div {...OverlayProps} id="hn-dropdown-lang" className="hn-dropdown hn-lang">
									<button
										className={`hn-dropdown-item ${ENV_NAME === "bhs" ? "active" : ""}`}
										onClick={() => changeLang("bhs")}
									>
										<Image className="hn-dropdown-item-icon lang-logo" src={IdIcon} alt="logo" />
										<div className="hn-dropdown-item-label">Bahasa Indonesia</div>
									</button>
									<button
										className={`hn-dropdown-item ${ENV_NAME === "eng" ? "active" : ""}`}
										onClick={() => changeLang("eng")}
									>
										<Image className="hn-dropdown-item-icon lang-logo" src={EnIcon} alt="logo" />
										<div className="hn-dropdown-item-label">English</div>
									</button>
								</div>
							)}
						</Overlay>
					</div> */}
					{isAuthenticated ? (
						<>
							<Link to={RoutePath.FAVORITE} className={showOverlay && searchFocus ? "show-desktop" : ""}>
								<div className="hn-menu">
									<div className="top-icon">
										<HeartIconFilled
											className="icon-hover"
											width="2.4rem"
											height="2.4rem"
											fill="#F24822"
										/>
										{checkActiveOn(location?.pathname, [RoutePath.FAVORITE]) ? (
											<HeartIconFilled
												className="icon-standby"
												width="2.4rem"
												height="2.4rem"
												fill="#F24822"
											/>
										) : (
											<HeartIconOutline
												className="icon-standby"
												width="2.4rem"
												height="2.4rem"
												stroke="#F24822"
											/>
										)}
									</div>
									<span className="hn-menu-label show-desktop">{`${Variable.FAVORITE[ENV_NAME]} (${
										favorites || 0
									})`}</span>
								</div>
							</Link>
							<div className={`hn-divider ${showOverlay && searchFocus ? "show-desktop" : ""}`} />
							<div
								className={`hn-menu ${showDropdown ? "active" : ""} ${
									showOverlay && searchFocus ? "show-desktop" : ""
								}`}
								onMouseEnter={() => openDropdown()}
								onMouseLeave={() => openDropdown(false)}
								onClick={() => openDropdown()}
								ref={profileRef}
							>
								<div className="top-icon">
									<UserCircleIconFilled
										className="icon-hover"
										width="2.4rem"
										height="2.4rem"
										fill="#204F8D"
									/>
									<UserCircleIconOutline
										className="icon-standby"
										width="2.4rem"
										height="2.4rem"
										stroke="#204F8D"
									/>
								</div>
								<span className="hn-menu-label show-desktop">
									{`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
								</span>
								<Overlay target={profileRef.current} show={showDropdown} placement="bottom">
									{({ placement, arrowProps, show: _show, popper, ...OverlayProps }) => (
										<div {...OverlayProps} id="hn-dropdown" className="hn-dropdown">
											<Link to={RoutePath.PROFILE} className="text-decoration-none">
												<button className="hn-dropdown-item">
													<UserCircleIconFilled
														className="hn-dropdown-item-icon"
														width="2.4rem"
														height="2.4rem"
														fill="#204F8D"
													/>
													<div className="hn-dropdown-item-label">
														{`${userDetails?.first_name || ""} ${
															userDetails?.last_name || ""
														}`}
													</div>
												</button>
											</Link>
											{userDetails?.role && (
												<Anchor href={"https://" + homeUrl} className="text-decoration-none">
													<button className="hn-dropdown-item">
														<IconPortalSekolah
															className="hn-dropdown-item-icon"
															width="2.4rem"
															height="2.4rem"
															fill="#204F8D"
														/>
														<div className="hn-dropdown-item-label">
															{Variable.DASHBOARD[ENV_NAME]}
														</div>
													</button>
												</Anchor>
											)}
											<button
												className="hn-dropdown-item"
												onClick={() => {
													openDropdown(false);
													props.logout();
												}}
											>
												<LogoutIconFilled
													className="hn-dropdown-item-icon"
													width="2.4rem"
													height="2.4rem"
													fill="#204F8D"
												/>
												<div className="hn-dropdown-item-label">
													{Variable.LOGOUT[ENV_NAME]}
												</div>
											</button>
										</div>
									)}
								</Overlay>
							</div>
						</>
					) : (
						<div>
							<Link to={RoutePath.CREATE_ACCOUNT} className="text-decoration-none">
								<button
									className={`btn btn-cta-secondary smaller-mobile-padding me-sm ${
										showOverlay && searchFocus ? "show-desktop" : ""
									}`}
								>
									{Variable.REGISTER[ENV_NAME]}
								</button>
							</Link>
							<button
								className={`btn btn-cta-primary smaller-mobile-padding ${
									showOverlay && searchFocus ? "show-desktop" : ""
								}`}
								onClick={() => setLoginModalShow(true)}
							>
								{Variable.SIGN_IN[ENV_NAME]}
							</button>
						</div>
					)}
					</div>
				</div>
			</nav>
			{showOverlay && searchRes && searchFocus && (
				<div
					className="search-res"
					ref={searchResRef}
					style={{
						left: searchRef?.current?.getBoundingClientRect()?.x || 0,
						top:
							(searchRef?.current?.getBoundingClientRect()?.y || 0) +
							(searchRef?.current?.getBoundingClientRect()?.height || 0) +
							10,
						width: searchRef?.current?.getBoundingClientRect()?.width || "100%",
					}}
				>
					{(searchRes?.college_results?.length > 0 || searchRes?.city_results?.length > 0) && (
						<>
							<div className="search-res-item header" key="header-college">
								<StudentIconOutline className="me-sm" stroke="#232230" width="2.4rem" height="2.4rem" />
								<h3 className="font-weight-semibold text-label-dark-gray-2 mb-0">
									{Variable.COLLEGE[ENV_NAME]}
								</h3>
							</div>
							{searchRes?.college_results?.map((i) => (
								<Link
									onClick={() => {
										openSearchRes(false);
										setSearchTemp("");
										setSearch("");
									}}
									className="text-decoration-none text-label-dark-gray-2"
									to={RoutePath.COLLEGE_DETAIL + "/" + i?.id}
									key={i?.id}
								>
									<div className="search-res-item hoverable">{i?.name}</div>
								</Link>
							))}
							{searchRes?.city_results?.map((i) => (
								<Link
									onClick={() => {
										openSearchRes(false);
										setSearchTemp("");
										setSearch("");
									}}
									className="text-decoration-none text-label-dark-gray-2"
									to={RoutePath.COLLEGE + "?city=" + i?.city}
									key={i?.id}
								>
									<div className="search-res-item hoverable">
										{formatString(Variable.SEARCH_COLLEGE_CITY[ENV_NAME], i?.city)}
									</div>
								</Link>
							))}
						</>
					)}
					{searchRes?.major_results?.length > 0 && (
						<>
							<div className="search-res-item header" key="header-major">
								<BookIconOutline className="me-sm" stroke="#232230" width="2.4rem" height="2.4rem" />
								<h3 className="font-weight-semibold text-label-dark-gray-2 mb-0">
									{Variable.MAJOR[ENV_NAME]}
								</h3>
							</div>
							{searchRes?.major_results?.map((i) => (
								<Link
									onClick={() => {
										openSearchRes(false);
										setSearchTemp("");
										setSearch("");
									}}
									className="text-decoration-none text-label-dark-gray-2"
									to={RoutePath.MAJOR_DETAIL + "/" + i?.id}
									key={i?.id}
								>
									<div className="search-res-item hoverable">
										<div className="font-weight-semibold me-xxs">{i?.major_name}</div>
										{`(${i?.college__name})`}
									</div>
								</Link>
							))}
						</>
					)}
					{searchRes?.career_results?.length > 0 && (
						<>
							<div className="search-res-item header" key="header-career">
								<SuitcaseIconOutline
									className="me-sm"
									stroke="#232230"
									width="2.4rem"
									height="2.4rem"
								/>
								<h3 className="font-weight-semibold text-label-dark-gray-2 mb-0">
									{Variable.CAREER[ENV_NAME]}
								</h3>
							</div>
							{searchRes?.career_results?.map((i) => (
								<Link
									onClick={() => {
										openSearchRes(false);
										setSearchTemp("");
										setSearch("");
									}}
									className="text-decoration-none text-label-dark-gray-2"
									to={RoutePath.CAREER_DETAIL + "/" + i?.id}
									key={i?.id}
								>
									<div className="search-res-item hoverable">{i?.career_name}</div>
								</Link>
							))}
						</>
					)}
					{searchRes?.scholarship_results?.length > 0 && (
						<>
							<div className="search-res-item header" key="header-scholarship">
								<GradCapIconOutline className="me-sm" stroke="#232230" width="2.4rem" height="2.4rem" />
								<h3 className="font-weight-semibold text-label-dark-gray-2 mb-0">
									{Variable.SCHOLARSHIP[ENV_NAME]}
								</h3>
							</div>
							{searchRes?.scholarship_results?.map((i) => (
								<Link
									onClick={() => {
										openSearchRes(false);
										setSearchTemp("");
										setSearch("");
									}}
									className="text-decoration-none text-label-dark-gray-2"
									to={RoutePath.SCHOLARSHIP_DETAIL + "/" + i?.id}
									key={i?.id}
								>
									<div className="search-res-item hoverable">{i?.title}</div>
								</Link>
							))}
						</>
					)}
					{search &&
						searchRes?.college_results?.length === 0 &&
						searchRes?.major_results?.length === 0 &&
						searchRes?.city_results?.length === 0 &&
						searchRes?.career_results?.length === 0 &&
						searchRes?.scholarship_results?.length === 0 && (
							<div className="search-res-item">
								{formatString(Variable.NO_ITEM_FOUND_QUERY[ENV_NAME], search)}
							</div>
						)}
				</div>
			)}
			<div className={`header-overlay ${showOverlay ? "show" : ""}`} />
			<WhatsappStickyBtn
				text={Variable.ASK_MORE[ENV_NAME]}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		userDetails: state.auth.userDetails,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		favorites: state.auth.favorites,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => dispatch({ type: ActionTypes.LOGOUT }),
		setLoginModalShow: (payload = true) => {
			if (payload) {
				dispatch({
					type: ActionTypes.OPEN_LOGIN_MODAL,
				});
			} else {
				dispatch({
					type: ActionTypes.CLOSE_LOGIN_MODAL,
				});
			}
		},
		loadFavorites: () => dispatch({ type: ActionTypes.FETCH_FAVORITES }),
		changeLanguage: (payload) =>
			dispatch({
				type: ActionTypes.UPDATE_LANGUAGE,
				payload: payload,
			}),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
